import {Helmet} from '@dr.pogodin/react-helmet';
import {DataStatus} from 'platform/components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetCustomTenantCatalogueUsageQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsSection, SettingsTemplate} from '@dms/settings/shared';

import {CustomCatalogueTable} from './components/CustomCatalogueTable';

export function VehicleCustomCatalogue() {
  // The completion toast links here, so arriving from it must not show the pre-replacement list.
  const {
    data: usage,
    isLoading,
    isError,
  } = useGetCustomTenantCatalogueUsageQuery(undefined, {refetchOnMountOrArgChange: true});

  const title = i18n.t('entity.customCatalogue.labels.title');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        header={{title}}
        description={i18n.t('entity.customCatalogue.labels.description')}
        isLoading={isLoading}
        isError={isError}
        data-testid={testIds.settings.vehicleCustomCatalogue('page')}
      >
        <SettingsSection>
          <DataStatus
            isEmpty={isNilOrEmpty(usage)}
            emptyMessage={i18n.t('entity.customCatalogue.labels.noEntries')}
            minHeight={40}
          >
            <CustomCatalogueTable
              data-testid={testIds.settings.vehicleCustomCatalogue('customCatalogue')}
            />
          </DataStatus>
        </SettingsSection>
      </SettingsTemplate>
    </>
  );
}
